// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsPayluddSubscriptions from '../../api/actionsPayluddSubscriptions';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import { columnsPayluddSubscription, columnsPayluddSubscriptionId } from './columnDef/columnsPayluddSubscriptions';
import Permissions from '@/app/permissions/Permissions';
import PAYLUDD_SUBSCRIPTIONS from '../../api/apiUrls';
import useSubscriptionStore from '@/app/store/modules/subscription';

/**
 * @param  root0
 * @param  root0.customQuery
 * @param root0.rowsSelected
 * @param root0.setRowsSelected
 * @param root0.organizationId
 * @param root0.filtersEventName
 * @returns {JSX}
 */
function PayluddSubscriptionsTable({
    customQuery = {},
    rowsSelected = undefined,
    setRowsSelected = undefined,
    filtersEventName
}) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { queryPayluddSubscriptions: queryStored, storeQueryPayluddSubscriptions } = useSubscriptionStore();

    // Constants
    const initialQuery = getInitialQuery(customQuery);
    const selectionMode = !!(rowsSelected && setRowsSelected);

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, refetch } = actionsPayluddSubscriptions.getPayluddSubscriptions(query, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && launchRefetch) {
            refetch(true);
            setLaunchRefetch(false);
        }
    }, [query, launchRefetch]);

    const allColumns = columnsPayluddSubscription({ query, setQuery, queryStored, storeQueryPayluddSubscriptions, setLaunchRefetch, selectionMode, filtersEventName });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            columnsId={columnsPayluddSubscriptionId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQueryPayluddSubscriptions}
            setLaunchRefetch={setLaunchRefetch}

            selectionMode={selectionMode}
            rowsSelected={rowsSelected}
            setRowsSelected={setRowsSelected}
            exportProps={{
                permissions: [
                    Permissions.EXPORT_PAYLUDD_POS_TERMINALS.name
                ],
                api: PAYLUDD_SUBSCRIPTIONS.EXPORT_POS_TERMINALS_PAYLUDD
            }}
        />
    );
}

PayluddSubscriptionsTable.propTypes = {
    customQuery: PropTypes.object,
    rowsSelected: PropTypes.object,
    setRowsSelected: PropTypes.func,
    filtersEventName: PropTypes.string
};

export default PayluddSubscriptionsTable;